export default __webpack_public_path__ + "static/media/Darcey 9781408312896.b5e86e62.jpg";